import createIcon from '../../createIcon';

/**
 * @component @name LteMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS41IDE0SDguNVYxNkgzLjVWOEg1LjVWMTRaTTguNSAxMEgxMC41VjE2SDEyLjVWMTBIMTQuNVY4SDguNVYxMFpNMjAuNSAxMFY4SDE1LjVWMTZIMjAuNVYxNEgxNy41VjEzSDIwLjVWMTFIMTcuNVYxMEgyMC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LteMobiledata = createIcon('LteMobiledata', [
  [
    'path',
    {
      d: 'M5.5 14H8.5V16H3.5V8H5.5V14ZM8.5 10H10.5V16H12.5V10H14.5V8H8.5V10ZM20.5 10V8H15.5V16H20.5V14H17.5V13H20.5V11H17.5V10H20.5Z',
      key: '139k2y',
    },
  ],
]);

export default LteMobiledata;
